import React from 'react';
import ReactLoading from "react-loading";

export const Loading = () => {
  return (<ReactLoading type='spin' color="#fff" height={20} width={20} />);
};
